import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import Skeleton from '@material-ui/lab/Skeleton';

import {
  CellSkeleton,
  CircleSkeleton,
  ContentArea,
  HeaderSkeletonRoot,
  Root,
  Status,
  Step
} from './MatchMakingLoader.styled';

const SKELETON_HEADER_KEYS = [0, 1, 2, 3, 4];

export const MatchMakingLoader = ({ status, step }) => {
  return (
    <>
      <HeaderSkeletonRoot elevation={0} role="progressbar">
        {SKELETON_HEADER_KEYS.map(id => (
          <CellSkeleton key={`header-cell-${id}`}>
            <CircleSkeleton variant="circle" width={20} height={20} />
            <Skeleton variant="rect" width="70%" height={20} />
          </CellSkeleton>
        ))}
      </HeaderSkeletonRoot>

      <Root>
        <LinearProgress />

        <ContentArea>
          <Status variant="h6">{status}</Status>
          {step && <Step variant="body1">{step}</Step>}
        </ContentArea>
      </Root>
    </>
  );
};
